import { flatttenGroups } from '../../utils/objectUtils';

export const allCommentsSelector = () => state => flatttenGroups(state.comments);

export const reportCommentsSelector = (reportKey) => state => reportKey ? state.comments[reportKey] : null;
